import * as CubiqTS from "shared/cubiq-model-multi-asset";
import { ContextMenuItemState } from "../../../../shared/cubiq-services";

export class BfxBlotterOpsIntContextMenuItemState extends ContextMenuItemState {
  public traderReference: Map<CubiqTS.AcceptanceType, string[]> = new Map<
    CubiqTS.AcceptanceType,
    string[]
  >();
  public pricingReference: Array<string> = new Array<string>(); // used for manual pricing unlock
  constructor() {
    super();
  }
}
